<template>
  <tr class="restriction-row">
    <td>
      {{ restriction.name }}
    </td>
    <td>
      <router-link :to="'/fleet/vehicles/' + restriction.Car.uuid">
        {{ restriction.Car.dropdownLabel }}
      </router-link>
    </td>
    <td>
      {{ period }}
    </td>
    <td>
      {{ times }}
    </td>
    <td>
      {{ days }}
    </td>
    <td>
      {{ bookableBy }}
    </td>
    <td>
      <router-link class="btn btn-sm btn-warning" :to="'/fleet/restrictions/edit/' + restriction.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
      <button class="btn btn-sm btn-danger" @click="deleteRestriction(restriction)">
        <span class="fa fa-trash-alt fa-fw"></span> Delete
      </button>
    </td>
  </tr>
</template>

<script>
import {
  DELETE_CAR_RESTRICTION
} from '@/vuex/types'
import { mapActions } from 'vuex'
export default {
  name: 'RestrictionRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    restriction () {
      return {
        AccountTypes: [],
        Accounts: [],
        dayRange: {},
        ...this.object
      }
    },
    bookableBy () {
      let accountTypes = ''
      if (this.restriction.AccountTypes.length > 0) {
        this.restriction.AccountTypes.forEach(function (type) {
          accountTypes += type.name + 's, '
        })
      }
      if (this.restriction.Accounts.length > 0) {
        this.restriction.Accounts.forEach(function (account) {
          accountTypes += account.fullName + ', '
        })
      }
      if (this.restriction.RestrictedToOrganizations.length !== 0) {
        this.restriction.RestrictedToOrganizations.forEach(function (org) {
          accountTypes += org.pageTitle + ', '
        })
      }
      if (accountTypes.length > 0) accountTypes = accountTypes.slice(0, -2)
      return accountTypes
    },
    times () {
      if (this.restriction.allTimes) {
        return '24 hours a day'
      } else {
        return `From ${moment(this.restriction.startTime).format('h:mm a')} to ${moment(this.restriction.endTime).format('h:mm a')}`
      }
    },
    period () {
      if (this.restriction.allDates) {
        return 'Every week of the year'
      } else {
        return `From ${moment(this.restriction.startDate).format('MMM Do YY')} to ${moment(this.restriction.endDate).format('MMM Do YY')}`
      }
    },
    days () {
      let dayString = ''
      if (this.restriction.dayRange.monday) dayString += 'Monday, '
      if (this.restriction.dayRange.tuesday) dayString += 'Tuesday, '
      if (this.restriction.dayRange.wednesday) dayString += 'Wednesday, '
      if (this.restriction.dayRange.thursday) dayString += 'Thursday, '
      if (this.restriction.dayRange.friday) dayString += 'Friday, '
      if (this.restriction.dayRange.saturday) dayString += 'Saturday, '
      if (this.restriction.dayRange.sunday) dayString += 'Sunday, '
      if (dayString.length === 0) {
        dayString = 'All days'
      } else {
        dayString = dayString.slice(0, -2)
      }
      return dayString
    }
  },
  methods: {
    async executeAction (action, payload) {
      await this[action](payload)
    },
    deleteRestriction (restriction) {
      this.executeAction(DELETE_CAR_RESTRICTION, restriction)
    },
    ...mapActions([
      DELETE_CAR_RESTRICTION
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/CarRestriction.vue